import { useMemo } from 'react';
import { MyLink } from '@app/components/ui-kit/Link';
import { declensionFactory } from '@app/helpers/declension';
import { useAppSelector } from '@app/redux/hooks';

import styles from './MapSelection.module.scss';

export const MapSelection = (): JSX.Element => {
  const { shopsList } = useAppSelector(state => state.header.data);
  const getTitle = declensionFactory('центр', 'центра', 'центров');
  const getTitleShop = declensionFactory('шинный', 'шинных', 'шинных');

  const stores = useMemo(() => {
    return shopsList?.filter(store => store.hasPickup) || [];
  }, [shopsList]);

  return (
    <div className={styles.Container}>
      <div className={styles.Content}>
        {stores?.length > 1 ? (
          <MyLink href="/shops/" data-testid="header-btn-shops">
            {`${stores?.length} ${getTitleShop(stores?.length)} ${getTitle(stores?.length)}`}
          </MyLink>
        ) : (
          <MyLink href={`/${stores[0]?.code}/`} data-testid="header-btn-shops">
            {stores[0]?.name}
          </MyLink>
        )}
      </div>
    </div>
  );
};
